/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  CreateFavoritesRequest,
  CreateFavoritesResponse,
  FavoritesResponse
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Get favorites for an account
 */
export const getFavorites = (

 options?: SecondParameter<typeof customInstance<FavoritesResponse>>,) => {
      return customInstance<FavoritesResponse>(
      {url: `/api/v1/favorites/listings`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Create favorites for a given account
 */
export const createFavorites = (
    createFavoritesRequest: CreateFavoritesRequest,
 options?: SecondParameter<typeof customInstance<CreateFavoritesResponse>>,) => {
      return customInstance<CreateFavoritesResponse>(
      {url: `/api/v1/favorites/listings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createFavoritesRequest
    },
      options);
    }
  /**
 * @summary Delete all favorites for an account
 */
export const deleteAllFavorites = (

 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/favorites/listings`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Delete a property from the Favorites list for an account
 */
export const deleteFavoriteByListingId = (
    listingId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/favorites/listing/${listingId}`, method: 'DELETE'
    },
      options);
    }
  export type GetFavoritesResult = NonNullable<Awaited<ReturnType<typeof getFavorites>>>
export type CreateFavoritesResult = NonNullable<Awaited<ReturnType<typeof createFavorites>>>
export type DeleteAllFavoritesResult = NonNullable<Awaited<ReturnType<typeof deleteAllFavorites>>>
export type DeleteFavoriteByListingIdResult = NonNullable<Awaited<ReturnType<typeof deleteFavoriteByListingId>>>
